<template>
  <v-card
    v-if="product"
    @click="openProductCard"
    class="ma-0 pa-0 mt-2 py-1 mx-2 product-card"
  >
    <v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0" cols="8">
        <vetalfa-section-item
          :hasMargins="false"
          :prop="`${product.name.trim()} (${product.brand.trim()})`"
        >
          <vetalfa-section-sub-item
            v-for="volume in product.volumes"
            :key="volume"
            :prop="volume"
          >
          </vetalfa-section-sub-item>
        </vetalfa-section-item>
      </v-col>
      <div v-if="product.animals.length">
        <div
          class="ma-0 pa-0"
          v-for="(animal, index) in product.animals"
          :key="animals.getAnimalDescription(animal)"
          v-bind:class="
            index == 0 ? 'product-first-animal' : 'product-second-animal'
          "
        >
          <v-img max-width="30px" :src="animals.getAnimalIcon(animal)"></v-img>
          <p class="product-animal-name ma-0 pa-0 mb-3 text-center">
            {{ animals.getAnimalDescription(animal) }}
          </p>
        </div>
      </div>
      <v-icon
        size="15"
        style="position: absolute; right: 8px; top: 40%"
        color="#004662"
        >{{ mdiChevronRight }}</v-icon
      >
    </v-row>
  </v-card>
</template>

<style>
.product-card {
  border-radius: 7px;
  min-height: 52px;
  background-color: white;
  cursor: pointer;
}
.product-name {
  color: #004662;
  font-size: 14px;
  font-style: italic;
  font-weight: bold;
  letter-spacing: 0;
}
.product-animal-name {
  height: 8px;
  color: #393a3a;
  font-size: 8px;
  letter-spacing: 0;
  line-height: 10px;
}
.v-card--link:focus:before {
  opacity: 0 !important;
}
.product-first-animal {
  position: absolute;
  z-index: 2;
  bottom: 5px;
  right: 34px;
}
.product-second-animal {
  position: absolute;
  z-index: 2;
  bottom: 5px;
  right: 74px;
}
</style>

<script>
import animals from "@/constants/animals.enum.js";
import { mdiChevronRight, mdiCircle } from "@mdi/js";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "ProductCard",
  props: {
    product: {
      type: Object,
    },
    isDrugsManagement: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("drugs", ["category"]),
    productCardColumns() {
      if (this.product.animals && this.product.animals.length) {
        switch (this.product.animals.length) {
          case 1:
            return 8;
          case 2:
            return 7;
        }
      }
      return 11;
    },
  },
  methods: {
    ...mapActions("general", ["routePathRedirect"]),
    ...mapMutations("drugs", ["setProduct"]),
    openProductCard() {
      if (this.isDrugsManagement) {
        this.setProduct(this.product);
      } else {
        this.routePathRedirect({
          path: `/categories/${
            this.$route.params.category || this.category.id
          }/products/${this.product.id}`,
        });
      }
    },
  },
  data() {
    return {
      animals,
      mdiChevronRight,
      mdiCircle,
    };
  },
  created() {
    this.product.animals.sort();
  },
};
</script>